import React from 'react';

export default () => ( 
    <section className="competition-main">
        <div className="columns">
            <div className="column is-full">
                <h1 className="subtitle is-3  has-text-weight-light">
                    Competitions
                </h1>
            </div>
        </div>
    </section>
)